import { W } from "@redchain/gen1-save";
import { ROM_PATCH_VERSION } from "@redchain/gen1-data";

export const CABLE_CLUB_MAP = 0xee;
export const CABLE_CLUB_PATCH = ROM_PATCH_VERSION;
export const LINK_TIMEOUT_START = 90;

export interface UnionRecord {
  type: "UNION";
  lobbyId: Uint8Array;
  dest: 1 | 2;
}

export interface LinkSide {
  patch: number;
  map: number;
  linkState: number;
  dest: number;
  timeout: number;
  saved: boolean;
  party: number;
  records: UnionRecord[];
  armed: boolean;
}

/** Refuse a Cable Club match before any UNION record is written. */
export function refusePatches(a: number, b: number): string | null {
  if (a !== CABLE_CLUB_PATCH || b !== CABLE_CLUB_PATCH) return "cable_club_patch";
  if (a !== b) return "patch_mismatch";
  return null;
}

/** Arm LinkController, then append UNION. Decline and the 30-second timeout never call this. */
export function commitUnion(arm: () => boolean | void, append: () => void): boolean {
  if (arm() === false) return false;
  append();
  return true;
}

/**
 * Arm first, then append UNION on this client. The other client does the same with the same lobby.
 * Decline and timeout never call this.
 */
export function acceptUnion(side: LinkSide, otherPatch: number, lobbyId: Uint8Array, dest: 1 | 2): void {
  const why = refusePatches(side.patch, otherPatch);
  if (why) throw new Error(why);
  side.armed = true;
  side.records.push({ type: "UNION", lobbyId: lobbyId.slice(), dest });
}

/** Writes wRedChainUnionDest only. Rejects a lobby this player did not accept. */
export function applyUnion(wram: Uint8Array, rec: UnionRecord, accepted: ReadonlySet<string>): void {
  const id = Buffer.from(rec.lobbyId).toString("hex");
  if (!accepted.has(id)) throw new Error("union_lobby_unknown");
  const party = wram[W.wPartyCount];
  wram[W.wRedChainUnionDest] = rec.dest;
  if (wram[W.wPartyCount] !== party) throw new Error("party");
}

/** Patch-10 entry: timeout is still its start value, then the link runs, then both return and save. */
export function enterLink(side: LinkSide): void {
  if (side.map !== CABLE_CLUB_MAP || side.linkState !== 0) throw new Error("not_in_club");
  if (side.dest !== 1 && side.dest !== 2) throw new Error("no_dest");
  side.timeout = LINK_TIMEOUT_START;
  side.saved = true;
  side.dest = 0;
}

export function finishLink(side: LinkSide): void {
  side.map = CABLE_CLUB_MAP;
  side.saved = true;
  side.linkState = 0;
}
